module.exports = __webpack_public_path__ + "img/edit_icon.a34c4607.svg";